export default __webpack_public_path__ + "static/media/Stratnel.a9a3cee2.png";